<template>
    <v-flex fill-height>
        <sidemainmenu></sidemainmenu>
        <br />
        <v-progress-linear slot="extension" :indeterminate="true"  v-if="loading" class="ma-0"></v-progress-linear>
        <v-layout wrap justify-space-between>
            <v-card  class="mx-auto" min-width="100%">
            <v-card-title>
                <v-form>
                    <v-flex>
                        <v-layout>
                            <v-flex>
                                <v-btn block color="warning" v-on:click="seen = !seen">Add New<v-icon right dark>add</v-icon></v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-form>
            </v-card-title>
            <v-alert :value="alertsuccess" color="success" icon="new_releases">
                {{ alertsmessage }}
            </v-alert>
            <v-alert :value="alerterror" color="error" icon="new_releases">
                <ul>
                    <li v-for="error in errors">{{ error }}</li>
                </ul>
            </v-alert>
            <v-card-text>
                <v-card v-if="seen">
                    <v-card-title>
                        Terminal Master
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="terminal" :search="search">
                        <template v-slot:items="props">
                            <td>{{ props.item.id }}</td>
                            <td class="text-xs-right">{{ props.item.name }}</td>
                            <td class="text-xs-right">{{ props.item.code }}</td>
                            <td class="text-xs-right">{{ props.item.port }}</td>
                            <td class="text-xs-right">{{ props.item.district }}</td>
                            <td class="text-xs-right">{{ props.item.state }}</td>
                            <td class="text-xs-right">{{ props.item.country }}</td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-card>
                <v-card  v-else>
                    <v-card-title>Add New Terminal
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text class="mx-auto">
                        <v-form v-model="valid" ref="form">
                        <v-container grid-list-xl>
                            <v-layout wrap justify-space-between>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtterminalname" label="Terminal Name" :rules="[(v) => !!v || 'Terminal Name is required']" required ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtterminalcode" label="Terminal Code" :rules="[(v) => !!v || 'Terminal Code is required']" required ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-select v-model="cboterminalport" :items="terminal_port" :rules="[(v) => !!v || 'Terminal Port is required']" item-value="id" item-text="text"></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap justify-space-between>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtdistrictname" label="District" :rules="[(v) => !!v || 'District is required']" required ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-select v-model="cbostateport" :items="state_list" item-value="id" item-text="text":rules="[(v) => !!v || 'State is required']"></v-select>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtcountry" label="Country" :rules="[(v) => !!v || 'Country is required']" required ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap justify-space-between>
                                <v-flex xs12 md4>
                                </v-flex>
                                <v-flex xs12 md4>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-btn color="success" v-bind:disabled="btnDisable" v-on:click="submitData()">Save</v-btn>
                                    <v-btn color="error" v-on:click="clearData()">Clear</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-card-text>
            </v-card>
        </v-layout>
    <br />
    <bottomfootermenus></bottomfootermenus>
    </v-flex>
</template>


<script>
import sidemainmenu from '@/components/header.vue';
import bottomfootermenus from '@/components/footer.vue';
import axios from 'axios';
    const toLower = text => {
            return text.toString().toLowerCase()
        }

        const searchByName = (items, term) => {
            if (term) {
              return items.filter(item => toLower(item.name).includes(toLower(term)))
            }

            return items
        }
  export default {
    name: 'terminal',
    data() {
        return {
            error: false,
            valid: false,
            alerterror: false,
            alertsuccess: false,
            alertsmessage: null,
            errors: null,
            seen: true,
            search: null,
            terminal: [],
            activeVal: "Open",
            btnDisable: false,
            loading: false,
            txtterminalname: null,
            txtterminalcode: null,
            cboterminalport: null,
            txtdistrictname: null,
            cbostateport: null,
            txtcountry: null,
            crossDomain : true,
            xhrFields: {
                withCredentials: true
            },
            search: '',
            headers: [
              { text: 'S.No', align: 'left', value: 'id' },
              { text: 'Terminal Name', align: 'right', value: 'name' },
              { text: 'Code', align: 'right', value: 'code' },
              { text: 'Port', align: 'right', value: 'port' },
              { text: 'District', align: 'right', value: 'district' },
              { text: 'State', align: 'right', value: 'state' },
              { text: 'Country', align: 'right', value: 'country' }
            ],
            terminal_port: [
                {
                  text: 'Tuticorin',
                  id: 1
                },
                {
                  text: 'Chennai',
                  id: 2
                }
              ]
        }
    },
    mounted:function(){
        this.getData(),
        this.getState()
    },
    components: {
        sidemainmenu,
        bottomfootermenus,
    },
    methods: {
        getData: function () {
            this.loading = true;
            this.API_URL = this.$hostname + "/masters/terminal"
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.loading = false;
                this.terminal = response.data;
            }, (error) => {
                this.loading = false;
                this.error = true;
            })
        },
        searchOnTable () {
            this.state = searchByName(this.state, this.search)
        },
        submitData: function() {
            if(!this.$refs.form.validate()) {
                return false
            }
            this.btnDisable = true;
            this.loading = true;
            const data = {'crossDomain': true,
                          'name': this.txtterminalname,
                          'code': this.txtterminalcode,
                          'port': this.cboterminalport,
                          'district': this.txtdistrictname,
                          'state': this.cbostateport,
                          'country': this.txtcountry,
                          'created_by': localStorage.username}
            axios.post(this.$hostname + '/masters/terminal', data,
                       { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
                 .then(response => {
                    this.btnDisable = false;
                    this.loading = false;
                    this.alertsuccess = true;
                    this.alertsmessage = response.data.message;
                    window.location.reload();
                 }, (error) => {
                    this.btnDisable = false;
                    this.loading = false;
                    this.alerterror = true;
                    this.errors = error.response.data.error;
                })
        },
        getState: function () {
            this.API_URL = this.$hostname + "/combos/state"
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.state_list = response.data;
            }, (error) => {
                this.error = true;
            })
        },
        clearData: function() {
            this.txtterminalname = null;
            this.txtterminalcode = null;
            this.cboterminalport = null;
            this.txtdistrictname = null;
            this.cbostateport = null;
            this.txtcountry = null;
        }
    }
  }
</script>
